<script setup lang="ts">
import type { CreationStep } from '@/composables/marketingFlowWithAudience'
import type { Icons } from '@/components/base/BaseIcon.vue'

const props = defineProps<{
  currentStep: CreationStep | null
  audienceName: string
  icon: Icons
}>()

const { t } = useI18n()

const isCompleted = computed(() => props.currentStep === 'completed')
</script>

<template>
  <div class="bg-white rounded-xl flex flex-col gap-5">
    <div class="flex gap-2.5 items-center justify-center w-full relative">
      <div v-if="isCompleted" class="bg-emerald-50 flex gap-2.5 items-center p-3.5 rounded-[26px] size-[52px]">
        <BaseIcon name="HeroCheckCircleIconSolid" class="h-6 w-6 text-emerald-500" />
      </div>

      <div v-else class="relative">
        <div class="bg-primary/10 flex gap-2.5 items-center p-3.5 rounded-[26px] size-[52px]">
          <BaseIcon :name="icon" class="h-6 w-6 text-primary" />
        </div>
        <div class="absolute -inset-1.5">
          <div class="w-full h-full border-4 border-transparent border-t-primary rounded-full animate-spin"></div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-2.5 items-start text-center w-full whitespace-pre-wrap">
      <p class="font-semibold text-lg leading-[26px] text-foreground w-full">
        {{
          isCompleted
            ? t('pages.autopilot.autopilotsPage.templates.creationSteps.successTitle')
            : t('pages.autopilot.autopilotsPage.templates.creationSteps.creatingTitle')
        }}
      </p>
      <p class="font-medium text-sm leading-6 text-foreground-secondary w-full">
        {{
          isCompleted
            ? t('pages.autopilot.autopilotsPage.templates.creationSteps.successDescription', { audienceName })
            : t('pages.autopilot.autopilotsPage.templates.creationSteps.creatingDescription', { audienceName })
        }}
      </p>
    </div>
  </div>
</template>
